/* eslint-disable func-names, max-len, no-new, no-underscore-dangle */
if ($('.upcoming-events').length > 0) {
  const eventResize = function eventResize() {
    $('.upcoming-events .event').css('height', 'auto');
    let eventHeight = 0; // the height of the highest element (after the function runs)

    $('.upcoming-events .event').each(function () {
      if ($(this).outerHeight() > eventHeight) {
        eventHeight = $(this).outerHeight();
      }
    });

    $('.upcoming-events .event').css('height', eventHeight);
  };
  eventResize();

  $(window).resize(() => {
    eventResize();
  });
}
